import api from '../config/api';
import { Binder, BinderDetail } from '../types';

export const binderService = {
  list: async (): Promise<Binder[]> => {
    const res = await api.get('/api/binders');
    return res.data;
  },

  getById: async (id: number): Promise<BinderDetail> => {
    const res = await api.get(`/api/binders/${id}`);
    return res.data;
  },

  create: async (data: Partial<Binder>): Promise<Binder> => {
    const res = await api.post('/api/binders', data);
    return res.data;
  },

  update: async (id: number, data: Partial<Binder>): Promise<Binder> => {
    const res = await api.put(`/api/binders/${id}`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/binders/${id}`);
  },

  addCards: async (binderId: number, cardIds: number[]): Promise<BinderDetail> => {
    const res = await api.post(`/api/binders/${binderId}/cards`, { card_ids: cardIds });
    return res.data;
  },

  removeCard: async (binderId: number, cardId: number): Promise<void> => {
    await api.delete(`/api/binders/${binderId}/cards/${cardId}`);
  },

  reorder: async (binderId: number, cardIds: number[]): Promise<BinderDetail> => {
    const res = await api.put(`/api/binders/${binderId}/reorder`, { card_ids: cardIds });
    return res.data;
  },
};
